import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { AccountSelect } from "@/components/FormBits";

const monthName = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-US", { month: "long", year: "numeric" });

export default function Statements() {
  const [accounts, setAccounts] = useState([]);
  const [sel, setSel] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/dashboard").then((r) => { setAccounts(r.data.accounts); if (r.data.accounts[0]) setSel(r.data.accounts[0].id); });
  }, []);
  useEffect(() => {
    if (sel) { api.get("/statements", { params: { account_id: sel } }).then((r) => setRows(r.data.statements)); }
  }, [sel]);

  return (
    <div data-testid="statements-page">
      <h1 className="text-4xl sm:text-5xl font-extrabold text-[var(--navy)] mb-2">Statements</h1>
      <p className="text-slate-500 mb-8">Monthly summaries of posted activity.</p>
      <div className="max-w-md mb-6"><AccountSelect accounts={accounts} value={sel} onChange={setSel} testid="statements-account-select" /></div>
      <div className="tile overflow-x-auto" data-testid="statements-table">
        <table className="w-full text-sm">
          <thead className="text-left text-slate-500"><tr>{["Period", "Opening", "Credits", "Debits", "Closing", "Items"].map((h) => <th key={h} className="px-5 py-3 font-semibold">{h}</th>)}</tr></thead>
          <tbody className="divide-y">
            {rows.map((s) => (
              <tr key={s.month} data-testid={`statement-${s.month}`}>
                <td className="px-5 py-3 font-semibold text-[var(--navy)]">{monthName(s.month)}</td>
                <td className="px-5 py-3">{money(s.opening)}</td>
                <td className="px-5 py-3 text-emerald-700">+{money(s.credits)}</td>
                <td className="px-5 py-3">-{money(s.debits)}</td>
                <td className="px-5 py-3 font-semibold">{money(s.closing)}</td>
                <td className="px-5 py-3">{s.count}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="px-5 py-8 text-center text-slate-500">No statements yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
